import { Grid,Typography } from "@mui/material";
import React from "react";

const SkillPriorityTableHeader: React.FC<Record<string, never>> = () => {
    return (
        <Grid
            container
            sx={{
                display: "flex",
                alignItems: "center",
                paddingLeft: "16px",
                paddingRight: "16px",
                paddingTop: "8px",
                paddingBottom: "8px",
            }}
        >
            <Grid
                item
                xs={1}
                display='flex'
                alignItems='center'
                justifyContent='center'
            >
                <Typography
                    sx={{
                        fontFamily: "Roboto",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(0, 0, 0, 0.87)",
                    }}
                >
                    Code
                </Typography>
            </Grid>
            <Grid
                item
                xs={1}
                display='flex'
                alignItems='center'
                justifyContent='center'
            >
                <Typography
                    sx={{
                        fontFamily: "Roboto",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(0, 0, 0, 0.87)",
                    }}
                >
                    Color
                </Typography>
            </Grid>
            <Grid
                item
                xs={2}
                display='flex'
                alignItems='center'
                justifyContent='flex-start'
            >
                <Typography
                    sx={{
                        fontFamily: "Roboto",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(0, 0, 0, 0.87)",
                        marginLeft: "12px",
                    }}
                >
                    Name
                </Typography>
            </Grid>
            <Grid
                item
                xs={6}
                display='flex'
                alignItems='center'
                justifyContent='flex-start'
            >
                <Typography
                    sx={{
                        fontFamily: "Roboto",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(0, 0, 0, 0.87)",
                    }}
                >
                    Description
                </Typography>
            </Grid>
            <Grid
                item
                xs={1}
                display='flex'
                alignItems='center'
                justifyContent='center'
            >
                <Typography
                    sx={{
                        fontFamily: "Roboto",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(0, 0, 0, 0.87)",
                    }}
                >
                    Multiplier
                </Typography>
            </Grid>
            <Grid
                item
                xs={1}
                display='flex'
                alignItems='center'
                justifyContent='center'
            >
                <Typography
                    sx={{
                        fontFamily: "Roboto",
                        fontWeight: 500,
                        fontSize: "14px",
                        color: "rgba(0, 0, 0, 0.87)",
                    }}
                >
                    Default
                </Typography>
            </Grid>
        </Grid>
    );
};

export default SkillPriorityTableHeader;